export const game1Click = (isSecondClick) => ({
    type: 'GAME_1_CLICK',
    isSecondClick
});

const initialState = {
    type: 'GAME_1_CLICK',
    isSecondClick: false
};

export default (state = initialState, action = {}) => {
    if (action.type === 'GAME_1_CLICK') {
        return Object.assign({}, {type: action.type, isSecondClick: action.isSecondClick})
    }
    return state;
}


// WEBPACK FOOTER //
// ./src/state/game1Click.js